module.exports = __webpack_public_path__ + "img/birch-logo.992d36db.png";